<template>
  <div class="loader-drop" v-if="show">
    <div class="loader">
      <div class="darksquare"></div>
      <div class="midsquare"></div>
      <div class="lightsquare"></div>
    </div>
    <div class="text-loader" v-if="text">{{ text }}</div>
  </div>
</template>

<script>
import bus from "@/bus";

export default {
  data() {
    return {
      show: true,
      text: null,
    };
  },
  mounted() {
    bus.$on("hide-loader", () => {
      this.show = false;
    });
    bus.$on("show-loader", (text) => {
      if (text == "") {
        this.text = null;
      } else {
        this.text = text;
      }
      this.show = true;
    });
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';

@keyframes anim {
  0% {
    width: 0px;
    height: 0px;
  }
  50% {
    width: 50px;
    height: 50px;
    bottom: 0;
  }
  100% {
    width: 10px;
    height: 10px;
    bottom: 60px;
  }
}

.loader-drop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  z-index: 9;
}
.loader,
.text-loader {
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.text-loader {
  top: 58%;
  white-space: pre;
}

.loader > * {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 25px;
  width: 50px;
  height: 50px;
  animation-name: anim;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
.darksquare {
  background-color: theme.$primary-color;
  animation-delay: -2s;
}
.midsquare {
  background-color: theme.$accent-color;
  left: -10px;
  animation-delay: -1s;
}
.lightsquare {
  background-color: theme.$accent-color-light;
  left: 10px;
}

@media (min-width: 768px) {
  .loader, .text-loader {
    margin-left: 150px;
  }
}
</style>